import { LayoutChooser } from '@food/ui';

export enum DefaultLayout {
	DESKTOP = 'desktop',
	TABLET = 'tablet',
	MOBILE = 'mobile',
}

export const defaultLayoutChooser: LayoutChooser = (width) => {
	if (width > 800) {
		return DefaultLayout.DESKTOP;
	}
	if (width > 500) {
		return DefaultLayout.TABLET;
	}
	return DefaultLayout.MOBILE;
};
